import selectInsurance from 'utils/selectInsurance';

const getInsuranceTradingPartnerName = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  return selectedInsurance
    && selectedInsurance['Insurance Info']
    && selectedInsurance['Insurance Info']['Change Info']
    && selectedInsurance['Insurance Info']['Change Info']['Trading Partner Name']
    ? selectedInsurance['Insurance Info']['Change Info']['Trading Partner Name'] : null;
};

export default getInsuranceTradingPartnerName;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceTradingPartnerName.js